import { defineStore } from 'pinia';
import type { Company, Brand, Location } from '@Shared';

export const useCompanyStore = defineStore('company', {
    state: () => ({
        company: null as Company | null,
        brand: null as Brand | null,
        companyLocations: [] as Location[],
        brokerageDetectionEnabled: false,
    }),

    actions: {
        setCompany(newCompany: Company) {
            this.company = newCompany;
        },
        setBrand(newBrand: Brand | null) {
            this.brand = newBrand;
        },
        setBrokerageDetectionEnabled(enabled: boolean) {
            this.brokerageDetectionEnabled = enabled;
        },
    }
});
